import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';

import amplitude from 'amplitude-js';
import { updateExtraByName } from 'apps/auth/actions/extraAction';
import { sendGtEvent } from 'apps/auth/analytics/analytics';
import { getEmptyMandatoryOrFieldsWithError } from 'apps/auth/components/form-multi/utils';
import CurrentFieldsScreen from 'apps/auth/components/profile/CurrentFieldsScreen';
import BasePage from 'apps/auth/components/utils/BasePage';
import { ONBOARDING_COMPLETED } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { SIGNUP_AMPLITUDE } from 'apps/auth/constants/amplitude/AmplitudeParamValues';
import { TOKEN_ID } from 'apps/auth/constants/Constants';
import { IS_NEW_USER } from 'apps/auth/constants/ExtraNames';
import { FINISH_REGISTRATION } from 'apps/auth/constants/formName';
import { GA4_SIGN_UP, GT_LOGIN_SUCCESS, GT_REG_SUCCESS } from 'apps/auth/constants/GoogleAnalyticsEvents';
import { GT_USER_ID } from 'apps/auth/constants/GoogleAnalyticsParamNames';
import { AUTH_REQUEST_MAIN_LINK, AUTH_SEND_MAIN_LINK } from 'apps/auth/constants/UrlConstants';
import { useAuth, useExtra } from 'apps/auth/hooks/selectors';
import Cookies from 'universal-cookie';

const cookies = new Cookies();

const RegistrationFinishPage = (props) => {
    const { phoneCountry, registrationFields, isNewUser, headlines } = useExtra();
    const { ballId, canSendMoney } = useAuth();
    const location = useLocation();
    const tokenId = cookies.get(TOKEN_ID);

    useEffect(() => {
        if (isNewUser) {
            amplitude.getInstance().logEvent(ONBOARDING_COMPLETED);
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ event: GA4_SIGN_UP });
            props.updateExtraByName(IS_NEW_USER, false);
        }
    }, [isNewUser]);

    useEffect(() => {
        if (location.search === '?login=completed') {
            sendGtEvent(GT_LOGIN_SUCCESS, { [GT_USER_ID]: ballId });
        } else if (location.search === '?registration=completed') {
            sendGtEvent(GT_REG_SUCCESS, { [GT_USER_ID]: ballId });
        }
    }, []);

    return (
        <CurrentFieldsScreen
            titleArr={headlines}
            formName={FINISH_REGISTRATION}
            phoneCountry={phoneCountry}
            action="/auth/profile/save/fields"
            location={canSendMoney ? AUTH_SEND_MAIN_LINK : AUTH_REQUEST_MAIN_LINK}
            extraFields={registrationFields}
            validationFunc={getEmptyMandatoryOrFieldsWithError}
            isSendEvent
            tokenId={tokenId}
            isNewUser={isNewUser}
            flow={SIGNUP_AMPLITUDE}
        />
    );
};

export default connect(null, { updateExtraByName })(BasePage(RegistrationFinishPage));
